/**
 * Orchestration Dashboard Styles
 */

import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 80vh;
`;

export const Header = styled.div`
  margin-bottom: 32px;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.text?.primary || '#fff'};
`;

// Re-export stats components from components/styles
export { StatsContainer, StatCard, StatValue, StatLabel } from './components/styles';
